// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whatsapp-preview {
  position: relative;
  max-width: 300px;
  width: max-content;
  box-shadow: 0 1px 0.5px rgba(11, 20, 26, 0.13);
  background-color: #d9fdd3;
  border-radius: 8px;
}

.whatsapp-preview .image-div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
}
.whatsapp-preview .image-div img {
  width: 100%;
  border-radius: 4px;
}
.whatsapp-preview .main {
  padding: 6px;
}
.whatsapp-preview .main p {
  margin: 0;
}
.whatsapp-preview-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 0.5px rgba(11, 20, 26, 0.13);
  background-color: #d9fdd3;
  width: 300px;
  border-radius: 8px;
  padding: 4px;
  font-size: 16px;
  margin-top: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/whatsapp.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB","sourcesContent":[".whatsapp-preview {\n  position: relative;\n  max-width: 300px;\n  width: max-content;\n  box-shadow: 0 1px 0.5px rgba(11, 20, 26, 0.13);\n  background-color: #d9fdd3;\n  border-radius: 8px;\n}\n\n.whatsapp-preview .image-div {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n}\n.whatsapp-preview .image-div img {\n  width: 100%;\n  border-radius: 4px;\n}\n.whatsapp-preview .main {\n  padding: 6px;\n}\n.whatsapp-preview .main p {\n  margin: 0;\n}\n.whatsapp-preview-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 1px 0.5px rgba(11, 20, 26, 0.13);\n  background-color: #d9fdd3;\n  width: 300px;\n  border-radius: 8px;\n  padding: 4px;\n  font-size: 16px;\n  margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
